<div class="image-panel__label">{{ 'cfg_imagePanel_subtitle' | translate }}</div>
<div class="image-panel__content">
  <div class="image-panel__tools">
  
    <div class="image-panel__images">
      <div class="image-panel__item" *ngFor="let image of userData.images" [ngStyle]="{'background-image': 'url('+(image.base64 ? image.base64 : image.thumb)+')' }" (click)="addImageLayer(image)">

      </div>
    </div>
  </div>
  <div class="image-panel__actions">
    <input class="image-panel__upload" type="file" id="file-select" (change)="browse($event)" />
    <label class="text-button" for="file-select"><span class="text-button__icon icon icon-download"></span><span class="text-button__label">{{ 'cfg_imagePanel_import' | translate }}</span></label>
    <progress-bar class="image-panel__progress" [current]="currentSize" [max]="maxSize" [unit]="'Mo'"></progress-bar>
  </div>
</div>

<app-modal id="modal-image-error" width="640" [blocking]="true" #ie>
  <p *ngIf="ie.data?.text" [innerHtml]="ie.data?.text | translate | replace:ie.data?.replaceList"></p>

  <div class="modal__buttons">
    <button class="button button--square" (click)='ie.close()'>
      <span>{{ 'btn_ok' | translate }}</span>
    </button>
  </div>
</app-modal>
